import { Box, ColorOptions, IconOptions, ModBox, Spacer, SpacerNew, TextNew } from '@jfs/ui-new'
import { FC, memo, useState } from 'react'
import { TooltipView } from '../../../../../../src/comps/TootTipView'
import { TextInputWithDelete } from '../../../../../comps/TextInputWithDelete'
import { pages, tooltipConfig } from '../../../../../util/util'
import { FileModeTextInput, PassKeyTextInput } from '../InfoDropDown'
import { styles } from '../ReportingStyles'
import { passwordPlaceholder } from '../helper'

export const FileTransferModeComponent: FC = memo(
  ({
    setFieldValue,
    fieldName,
    allValues,
    label,
    editable,
    sUpdate,
    isNewPassword,
    setIsNewPassword,
    ...prop
  }: any) => {
    const [passwordError, setPasswordError] = useState('')
    const [sNewPassword, setNewPassword] = useState(isNewPassword?.email)

    const updateEmailConfig = (value: any, key: any) => {
      const currentFiled = Object.assign({}, allValues[fieldName])
      currentFiled[key] = value
      //setFiledObject((prev: any) => ({ ...prev, [fieldName]: currentFiled }))
      validateTheFieldValue(value, key)
      setFieldValue(fieldName, currentFiled)
    }

    const regexPass = /^[a-zA-Z0-9]{8,40}$/
    const validateTheFieldValue = (value: any, key: any): any => {
      if (key === 'emailConfigPassKey') {
        setNewPassword(true)
        if (value === passwordPlaceholder) {
          setIsNewPassword?.('email', false)
        } else {
          setIsNewPassword?.('email', true)
        }
        if (sUpdate && !sNewPassword) {
          //console.log('old pass ')
          return true
        } else if (value?.length > 0 && value !== passwordPlaceholder) {
          //console.log('new pass ', regexPass)
          if (!regexPass.test(value)) {
            setPasswordError(
              'Password invalid, Password must contain 8 alpha-numeric characters. Special characters are not allowed.',
            )
            return false
          } else {
            setPasswordError('')
            return false
          }
        }
      }
    }

    return (
      <Box {...styles.mainView}>
        <SpacerNew size={15} direction={'vertical'} />

        {fieldName === 'emailFileTransferConfig' && (
          <>
            <Box {...styles.textAndIcon}>
              <Box {...styles.titleAligner}>
                <TextNew title={label} {...styles.titleText} />
              </Box>
              <Box>
                {/* <IconNew id={'INFO'} color={'#202F4D8A' as ColorOptions} size={14} /> */}
                <TooltipView
                  iconColor={'#202F4D8A' as ColorOptions}
                  fontSize={12}
                  value={tooltipConfig.emailConfigInfo}
                  top={-35}
                  alignLeft={true}
                  iconSize={14}
                />
              </Box>
            </Box>
            <SpacerNew size={5} direction={'vertical'} />

            <Box {...styles.configurationContainer}>
              <SpacerNew size={15} direction={'vertical'} />

              <TextInputWithDelete
                fieldName={fieldName}
                label={prop?.config.recipients ?? pages.create_config.email_recipients}
                placeholder={prop?.config.recipients ?? pages.create_config.email_recipients}
                editable={editable}
                //setFieldValue={setFieldValue}
                setFieldValue={(val: any) => updateEmailConfig(val, 'emailRecipients')}
                value={allValues[fieldName]?.emailRecipients}
                title={prop?.config.recipients ?? pages.create_config.email_recipients}
                isEmail={true}
                touched={true}
                gridHeight={60}
                badgeWidth={250}
                error="Please enter Email ID followed by comma , or space"
                testID="email_recipients"
                allValues={allValues}
                color={'#528BFF' as ColorOptions}
                borderColor={'#B9CBF0' as ColorOptions}
                titleColor={'#202F4D8A' as ColorOptions}
                setValuesOnFieldNameObject={true}
                fieldNameObjectKey={'emailRecipients'}
                bgColor={'#EAF1FF' as ColorOptions}
                valuesBorderColor={'TRANSPARENT'}
                fontFamily={'jiotype-medium'}
                borderRadius={4}
                showToolTipInfo={true}
                toolTipInfoComponent={
                  <TooltipView
                    iconColor={'#202F4D8A' as ColorOptions}
                    fontSize={12}
                    value={tooltipConfig.emailConfigRecipentsInfo}
                    top={-25}
                    alignLeft={true}
                    iconSize={14}
                  />
                }
              />

              <SpacerNew size={15} direction={'vertical'} />
              <FileModeTextInput
                onChangeText={(val: string) => updateEmailConfig(val, 'emailConfigSubjLine')}
                //value={fieldObject.emailSubject}
                value={allValues[fieldName]?.emailConfigSubjLine}
                fieldName={fieldName}
                allValues={allValues}
                editable={editable}
                title={pages.create_config.subject_line}
                placeHolder={pages.create_config.subject_line_placeholder}
                width={'100%'}
                secureTextEntry={false}
                maxLength={150}
                tooltipInfo={tooltipConfig.emailConfigSubjInfo}
                isOptional={true}
                insertDateTime={true}
                top={-50}
              />

              <SpacerNew size={15} direction={'vertical'} />
              <ModBox flexDirection={'row'}>
                <Box f={1} flexDirection="row" flex={1}>
                  <FileModeTextInput
                    onChangeText={(val: string) => updateEmailConfig(val, 'emailConfigFileName')}
                    //value={fieldObject.emailFile}
                    value={allValues[fieldName]?.emailConfigFileName}
                    fieldName={fieldName}
                    allValues={allValues}
                    editable={editable}
                    title={pages.create_config.filename}
                    placeHolder={pages.create_config.filename_placeholder}
                    secureTextEntry={false}
                    rightIcon={'LOCK' as IconOptions}
                    rightOnPress={() => console.log('icon pressed')}
                    maxLength={25}
                    width={'100%'}
                    tooltipInfo={tooltipConfig.emailConfigFileNameInfo}
                    isOptional={true}
                    top={-20}
                    insertDateTime={true}
                    autoComplete={'new-password'}
                  />

                  <Spacer size={20} direction={'horizontal'} />

                  <PassKeyTextInput
                    onChangeText={(val: string) => updateEmailConfig(val, 'emailConfigPassKey')}
                    //value={fieldObject.emailFilePassKey}
                    value={allValues[fieldName]?.emailConfigPassKey}
                    fieldName={fieldName}
                    allValues={allValues}
                    editable={editable}
                    title={pages.create_config.passkey}
                    placeHolder={pages.create_config.passkey_placeholder}
                    secureTextEntry={true}
                    rightAction={'Reset'}
                    error={passwordError}
                    rightOnPress={() => updateEmailConfig('', 'emailConfigPassKey')}
                    maxLength={40}
                    tooltipInfo={tooltipConfig.emailConfigPassKeyInfo}
                    top={-35}
                    sUpdate={sUpdate}
                    autoComplete={'new-password'}
                  />
                </Box>
              </ModBox>

              <SpacerNew size={15} direction={'vertical'} />
            </Box>
          </>
        )}
      </Box>
    )
  },
)
